define('models/goalMonitoringReport',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.GoalMonitoringReport = T1Model.extend({});
  return T1.Models.GoalMonitoringReport;
});
